// extracted by mini-css-extract-plugin
export default {"calendar":"KjK0m","mobile":"_5vbJd"};